import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useInteractWithApps = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    return useMutation(variables => client.mutation({
        name: 'interactWithApps',
        args: {
            fields,
            variables,
        },
    }), useMutationOptions);
};
//# sourceMappingURL=useInteractWithApps.js.map